import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import _ from 'lodash'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'

const GoogleHeader = () => {
  const { classData, objectData, variables, passType } = useContext(PassContext)

  let header = getHeader({ classData, objectData, variables, passType })
  let subheader = getSubHeader({ classData, objectData, variables, passType })

  return (
    <div className="flex flex-col header">
      <SubHeader subheader={subheader} />
      <Header header={header} />
    </div>
  )
}

export default GoogleHeader


const Header = ({ header }) => {
  if (header.editable) {
    return (
      <PopupEditor title={header.title} path={header.path} sources={header.sources} required={true} variable={header.variable}>
        <div className="value editable">{header.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="value">{header.value}</div>)
  }
}

const SubHeader = ({ subheader }) => {
  if (subheader.editable) {
    return (
      <PopupEditor title={subheader.title} path={subheader.path} sources={subheader.sources} type={subheader.type} variable={subheader.variable}>
        <div className="label editable">{subheader.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="label">{subheader.value}</div>)
  }
}

const getHeader = ({ classData, objectData, variables, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "header.defaultValue.value",
            title: "Header",
            variable: "pass.header",
            value: dataSelector({ objectData, variables, path: "header.defaultValue.value" }) ?? ""// Mandatory
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "eventName.defaultValue.value",
          title: "Event Name",
          variable: "event.name",
          value: dataSelector({ objectData:classData, variables, path: "eventName.defaultValue.value" }) ?? ""// Mandatory
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          const { firstLeg, lastLeg } = getTransitLegs({ variables })
          return {
            editable: false,
            value: <>{firstLeg.origin.code}<TransitIcon objectData={objectData} variables={variables} styles={{ fontSize: 50 }} />{lastLeg.destination.code}</>
          }
        }

      case "offer":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "title",
            title: "Offer Title",
            variable: "pass.title",
            value: dataSelector({ objectData:classData, variables, path: "title" }) ?? ""// Mandatory
          }
        }
      case "loyalty":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "programName",
            title: "Program Name",
            variable: "pass.program_name",
            value: dataSelector({ objectData:classData, variables, path: "programName" }) ?? ""// Mandatory
          }
        }

      case "giftCard": {
        return {
          editable: true,
          sources: ["object"],
          path: "balance.micros",
          title: "Balance",
          variable:"gift.balance",
          value: getBalanceHeader({ objectData, variables })
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const getSubHeader = ({ classData, objectData, variables, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "subheader.defaultValue.value",
            title: "Sub Header",
            variable: "pass.subheader",
            value: dataSelector({ objectData, variables, path: "subheader.defaultValue.value" }) ?? ""
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "venue.name.defaultValue.value",
          title: "Event Venue",
          variable: "event.venue.name",
          value: dataSelector({ objectData:classData, variables, path: "venue.name.defaultValue.value" }) ?? "",
          type : "venue"
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          const { firstLeg, lastLeg } = getTransitLegs({ variables })
          return {
            editable: false,
            value: `${firstLeg.origin.name} to ${lastLeg.destination.name}`
          }
        }

      case "offer":
        {
          // Not applicable
          return {
            editable: false
          }
        }
      case "loyalty":
        {
          // Not applicable
          return {
            editable: false
          }
        }

      case "giftCard": {
        // Not applicable!
        return {
          editable: false
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}


const getTransitLegs = ({ variables }) => {

  let legs = variables.journey.legs

  const resolvedLegs = dataSelector({ objectData: { legs }, variables, path: "legs" })

  let firstLeg = resolvedLegs[0]
  let lastLeg = resolvedLegs[resolvedLegs.length - 1]

  return ({ firstLeg, lastLeg })
}


const TransitIcon = ({ objectData, variables, styles }) => {

  const tripType = dataSelector({ objectData, variables, path: "tripType" })

  switch (tripType.toUpperCase()) {
    case "ONE_WAY": return <ArrowForwardIcon style={styles} />
    case "ROUND_TRIP": return <SwapHorizIcon style={styles} />
  }
}

const getBalanceHeader = ({ objectData, variables }) => {
  const resolvedBalance = dataSelector({ objectData, variables, path: "balance" })
  const microsString = Number(resolvedBalance.micros.toString().replace(/[^0-9.-]+/g,""));
  return "Gift Card: " + microsString.toLocaleString('en-US', { style: 'currency', currency: resolvedBalance.currencyCode, minimumFractionDigits: 0 })
}